{
	"resourceType": "Questionnaire",
	"meta": {
		"profile": ["http://hl7.org/fhir/4.0/StructureDefinition/Questionnaire"]
	},
	"url": "http://reference-data.careconnect.be/api/fhir/Questionnaire/VAS",
	"name": "VAS",
	"language": "nl-BE",
	"status": "active",
	"publisher": "Corilus NV",
	"title": "VAS",
	"purpose": "Meet de intensiteit van pijn via een visuele schaal",
	"description": "Pijncontrole bij de patiënt aan de hand van zelfrapportage op een één-item schaal.",
	"item": [
		{
			"linkId": "110200",
			"text": "Waar op een schaal van 0 tot 10 bevindt zich uw pijn? (0 = geen pijn, 10 = ergst denkbare pijn)",
			"type": "integer",
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/minValue",
					"valueInteger": 0
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/maxValue",
					"valueInteger": 10
				}
			],
			"required": true
		}
	]
}
